var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1073.03 393.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.53,380.5s-1.91,8.4,24,3c24-5,41.61-9.11,69-2s45.74,9.91,49-3,16-60,6-63-48-7-53-5-12,1-13,5,0,36,1,43,2,17,6,18,43,3,49-2,13-14,4-18-24,0-31,0-30,4-29-9c.65-8.46,7-10,19-9s36,4,45,1c6.71-2.24,9-23,0-24s-19-6-20,1c-1.28,8.96-2,48.93-2,56,0,6,0,13-11,13-8,0-8-13-8-22,0-16.12,0-26-3-36s-8-20-18-22c-4.34-.87-17-1-16-6l13-42s6-23-3-21c-11.75,2.61-14,18-8,24s10.68-18.11,8-19c-3-1-9,9-6,15,2.23,4.45,7.76,3.95,10.46,3.39,1.16-.24,2.36-.23,3.52,0l48.01,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.53,238.5s58.5,9.34,62,14c3,4,5,10,2,16-4.12,8.25-4-5-9,18-1.06,4.89-5.69,25.44-14,26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.53,
    y1: 270.5,
    x2: 142.03,
    y2: 271
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.53,291.5l5.58-19s7.57,0,9.42,5-4.35,8.65-9,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105.53,276.5l-7,20s4.91-11.04,10-9,0,12,0,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m122.53,279.5l-5.92,20s11.31.22,13.92-5c1-2,6-11-8-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.64,241.24s-8.94-14.99,11.97-21.87,70.73-20.37,70.73-20.37c0,0-11.92-12.49-13.81-30.5-2-19,15-34,9-34h-11l1-12-18.52,2.57,31.52-36.57h93l-24,33-77,2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.53 133.5 243.43 132.13 245.06 122.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m243.43,132.13s18.26,19.63,9.11,49.37c-4,13-9,14-9,14,0,0,21,5,27,33s7,63-12,68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 270.96,
    y1: 98.91,
    x2: 270.96,
    y2: 148.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "274.38 111.51 266.53 116.5 275.72 116.5 266.53 121.11 274.38 121.11 267.53 126.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 188.53,
    y1: 157.5,
    x2: 200.05,
    y2: 157.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 227.53,
    y1: 157.5,
    x2: 239.05,
    y2: 157.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 207.53,
    y1: 180.5,
    x2: 223.67,
    y2: 180.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.42,244.98s47.12-13.48,52.12-11.48,6.97,19.5,6.48,37.25.07,79.13.52,93.75,5.93,18.12,13,19c8,1,9-4,11-12,2.92-11.68,4-77,4-77,0,0,13,1,18,0,5.31-1.06-1.87,81.63,6,86,9,5,17,1,19-6s6.37-136.2,2-141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m256.14,353.59s-2.61,19.91,12.39,22.91,25-7,54-5,62,16,90,1c8.64-4.63,11.9-3.7,22-11,22.61-16.34,41.11-35.72,41-53-.17-25-5.83-29.72,6-58s18-34,18-34c0,0-20.12,7.07-33-15-7-12-12-31-11-50,.69-13.13,2.88-22.74,13-24,8-1,10.3,5.89,9.64,30-.64,23,4.36,35,18.36,38,12.86,2.76,13-1,13-5s-11-19-3-35c8.4-16.8,22.56-29.86,46-24,16,4,36.84,24.29,27,51-7,19-21,15-12,24,0,0,37.31,53.01,33.37,73-2.37,12-13.27,7-21.37-7-11.84-20.49-20-40-20-44s-8,39-10,51c-3.91,23.45,3,30-4,56-8.06,29.95-34,60-49,42-8.61-10.34,23-28,26-49s-1.05-30-3-34-6-7-11-7c-2.24,0-3,22-5,29-7.92,27.73-34.13,56-53,56-12,0-14-13-7-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "463.53 81.5 461.53 29.5 530.53 1.5 532.53 52.5 552.53 94.5 483.06 122.42 463.53 81.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 463.53,
    y1: 81.5,
    x2: 532.53,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "467.53 33.5 525.53 10.5 527.53 48.5 469.53 73.5 467.53 33.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.53,
    y1: 86.5,
    x2: 516.53,
    y2: 70.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.53,
    y1: 68.5,
    x2: 528.53,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.53,
    y1: 94.5,
    x2: 493.53,
    y2: 89.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 502.53,
    y1: 86.5,
    x2: 532.53,
    y2: 73.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.53,
    y1: 103.5,
    x2: 514.53,
    y2: 91.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.44,
    y1: 111.51,
    x2: 540.66,
    y2: 88.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.46,
    y1: 88.5,
    x2: 537.67,
    y2: 81.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m470.24,95.55s-15.71,7.95-15.71,31.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m472.53,111.5s-9,3-11,19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.53,
    y1: 33.5,
    x2: 500.03,
    y2: 50.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "516.53 31.5 510.53 42.5 519.53 46.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "485.53 42.5 494.53 46.5 487.53 57.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.34,
    y1: 46.5,
    x2: 478.03,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 479.34,
    y1: 56.5,
    x2: 479.03,
    y2: 56.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m528.53,186.34s9.4-8,17.5,4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m878.53,224.5l-20,7s2.57,142.72-3,152c-3,5-14.86,8.47-20,1s-4.14-88-4.14-88h-16.86s-3,64-5,79-8.73,16.87-20,11-1.61-147.22-7-145c-17,7-29.24,7.12-31-6-.76-5.69,14.98-51.37,23-61,5-6,13.26-6,17,5s-16,47-16,47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m524.53,374.5s9-3,28,.73c34.37,6.75,69-4.73,132-2.73,53.06,1.68,52-5,105,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m763.63,148.5s-25.47-18.58-18.09-23c5-3,12,4,12,4,0,0,3-12,8-8,5.44,4.35-5,20-1.91,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m778.53,170.5s-9-42,36-50c40.77-7.25,55,26,50,44-1.14,4.09-1,24-1,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m870.69,223.94s-5.48-2-14.84-8.35c-10.54-7.14-26.54-23.73-20.16-30.75,3.36-3.7,6.91-6.42,20.58,1.14,13.55,7.49,30.68,26.71,30.36,30.83-.87,11.37-15.94,7.14-15.94,7.14Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.53,
    y1: 170.5,
    x2: 862.53,
    y2: 168.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.34,
    y1: 214.46,
    x2: 853.53,
    y2: 214.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "791.53 169.5 791.53 157.5 812.53 157.5 812.53 169.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 816.53,
    cy: 193.5,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 817.03,
    cy: 193,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m857.53,378.5s0,12,13,10c43.77-6.73,40.01,1.31,66.55,3.22,66.45,4.78,51.45-31.22,134.45-27.22"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.315425a174931b249d14d827c1465c82.svg";
export { ForwardRef as ReactComponent };